<template>
<div class="kt-widget__content">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>